import "../scss/app.scss";
import "./ImportSprites";
import "./SmoothScroll";
import "./Tabs";
import "./Sliders";
import './Mask'
import './SvgAnimation'
import './BlockAnim'
import './Nav'
import './StickyMenu'
import './Modal'